export const RsFormInitialState: RsFormState = {}
export type RsFormState<T = any> = Record<string, T>
